module.exports = __webpack_public_path__ + "static/media/required.4adba009.svg";